import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import { Restore as RestoreIcon } from '@material-ui/icons';


interface IProps {
    size?: 'small' | 'medium'
    stopPropagation?: boolean
    onClick: () => void
}

let RestoreIconButton = ({ size = 'small', stopPropagation, onClick }: IProps) => {
    return (
        <Tooltip title="Restore" TransitionComponent={Zoom}>
            <IconButton
                size={size}
                color="secondary"
                onClick={ev => {
                    if (stopPropagation === true) {
                        ev.stopPropagation();
                    }
                    onClick();
                }}
            >
                <RestoreIcon />
            </IconButton>
        </Tooltip>
    )
}

export default RestoreIconButton;